const sizeChart = () => {
  const modal = document.querySelector('#myModal');

  if (modal) {
    const modalOpenBtn = document.querySelector('.open-size-chart');
    const modalCloseBtn = document.querySelector('.close-size-chart');
    let country;

    // open modal
    modalOpenBtn.addEventListener('click', () => {
      modal.style.display = 'block';
    });

    // close modal
    modalCloseBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }

    if (window.screen.width < 768) {
      const measureContainer = document.querySelector('.header-title__right');
      document.querySelector('.header-content').after(measureContainer);
    }

    // function to show/hide size chart table
    const sizeChartBtns = document.querySelectorAll('.country-sizes-btn__btn');

    sizeChartBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        country = btn.getAttribute('data-country');
        showTableCountry(country);
      });
    });

    // function to show/hide measurement
    const measurementBtns = document.querySelectorAll('.measurement-btn input');

    measurementBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const measure = e.currentTarget.value;
        const currentCountry = document.querySelector('.country-sizes-btn__btn.active').getAttribute('data-country');
        changeMeasure(measure, currentCountry);
      });
    });

  }
}

const showTableCountry = (country) => {
  const btns = document.querySelectorAll('.country-sizes-btn__btn');
  const tables = document.querySelectorAll('.header-content .table');
  const currentMeasure = document.querySelector('.measurement-btn input:checked').value;

  btns.forEach(btn => {
    btn.classList.remove('active');
    btn.getAttribute('data-country') === country ? btn.classList.add('active') : null;
  });

  tables.forEach(table => {
    table.classList.remove('hidden');
    table.getAttribute('data-table') === country ? null : table.classList.add('hidden');
  });

  changeMeasure(currentMeasure, country);

}

const changeMeasure = (measure, country) => {
  console.log(measure, country);
  const measureTable = document.querySelector(`.table[data-table="${country}"]`);

  const measureCol = measureTable.querySelectorAll('.measurement');

  measureCol.forEach(col => {
    col.classList.remove('hidden');
    col.getAttribute('data-measure') === measure ? null : col.classList.add('hidden');
  })
}

export default sizeChart;
